export default "__VITE_ASSET__B1IIM53w__"